export const colorName = (color?: number) => {
    switch (color) {
        case 1: return "Positivo (verde)";
        case 2: return "Negativo (vermelho)";
        case 3: return "Neutro (azul)";
        case 4: return "Atenção (amarelo)";
        default: return "Padrão";
    }
};

